import {
  BUMP_PENDING_REVIEW_THREAD_COUNT,
  CHANGE_THREAD_OWNER,
  GET_REVIEW_CHATS_FAILED,
  GET_REVIEW_CHATS_STARTED,
  GET_REVIEW_CHATS_SUCCESS,
  GET_REVIEW_MESSAGE_FROM_PUSH,
  GET_REVIEW_THREAD_STARTED,
  GET_REVIEW_THREAD_SUCCESS,
  OPTING_IN_GUEST_TO_CHAT_SUCCESS,
  OPTING_OUT_GUEST_FROM_CHAT_SUCCESS,
  RESOLVE_THREAD_REVIEW_STARTED,
  RESOLVE_THREAD_REVIEW_SUCCESS,
  SEND_REVIEW_MESSAGE_STARTED,
  SEND_REVIEW_MESSAGE_SUCCESS,
  UPDATE_PENDING_THREAD_COUNT,
  UPDATE_REVIEW_TYPING_USERS,
  UPDATE_SINGLE_REVIEW_TYPING_USER
} from '../actions/actionTypes'

const defaultState = {
  loading: true,
  currentchatId: null,
  threadLoading: false,
  newMessage: null,
  threads: {},
  typingUsers: {},
  pendingThreadsCount: 0
}

export default function messaging(
  state = {
    ...defaultState
  },
  action
) {
  switch (action.type) {
    case UPDATE_PENDING_THREAD_COUNT:
      return {
        ...state,
        pendingThreadsCount: action.payload.pendingMessageCountForAfter
      }

    case BUMP_PENDING_REVIEW_THREAD_COUNT:
      return {
        ...state,
        pendingThreadsCount: state.pendingThreadsCount + action.payload
      }

    case 'POST_AND_SELECT_SUBSIDIARY_STARTED':
      return {
        ...defaultState
      }

    case GET_REVIEW_CHATS_STARTED:
      return {
        ...state,
        loading: true
      }

    case GET_REVIEW_CHATS_SUCCESS:
      return {
        ...state,
        loading: false,
        threadsUpdatedOn: Date.now(),
        threads: {
          ...state.threads,
          ...action.payload.reduce(
            (p, c) => ({
              ...p,
              [c.chatId]: {
                ...(state.threads[c.chatId] ? state.threads[c.chatId] : {}),
                ...c,
                messages: state.threads[c.chatId] ? state.threads[c.chatId].messages : []
              }
            }),
            {}
          )
        }
      }

    case GET_REVIEW_THREAD_STARTED:
      return {
        ...state,
        currentchatId: action.payload.chatId,
        threadLoading: true
      }

    case GET_REVIEW_CHATS_FAILED:
      return {
        ...state,
        currentchatId: null,
        threadLoading: false
      }

    case GET_REVIEW_THREAD_SUCCESS:
      return {
        ...state,
        threadLoading: false,
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            ...action.payload,
            updatedOn: Date.now()
          }
        }
      }

    case GET_REVIEW_MESSAGE_FROM_PUSH: {
      const { subscriberId, message, status } = action.payload
      const { chatMessageId } = message

      // find chat id using subscriber id

      const chatId = Object.keys(state.threads).find(
        chatId => state.threads[chatId].subscriberId === subscriberId
      )

      if (!chatId) {
        return { ...state }
      }

      if (!state.threads[chatId]) {
        return { ...state }
      }

      const newCount = message.isSenderClient
        ? state.threads[chatId].messages
            .slice()
            .reverse()
            .findIndex(m => !m.isSenderClient) + 1
        : 0

      const oldMessage =
        state.threads[chatId].messages.find(o => o.chatMessageId === chatMessageId) || {}

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            lastMessage: message.content,
            lastMessageOn: message.finalizedOn,
            waitingMessageCount: newCount,
            lastMessageBotIntent: message.botIntent,
            status,
            messages: [
              ...state.threads[chatId].messages.filter(
                o => o.chatMessageId !== chatMessageId
              ),
              { ...oldMessage, ...message }
            ]
          }
        }
      }
    }

    case SEND_REVIEW_MESSAGE_STARTED: {
      const { chatId, message } = action.payload

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            messages: [...state.threads[chatId].messages, message]
          }
        }
      }
    }

    case SEND_REVIEW_MESSAGE_SUCCESS: {
      const { chatId, message } = action.payload
      const controlKey = message.requestControlKeyEcho

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            status: 'AgentResponded',
            waitingMessageCount: 0,
            messages: [
              ...state.threads[chatId].messages.filter(o => o.controlKey !== controlKey),
              message
            ]
          }
        }
      }
    }

    case UPDATE_REVIEW_TYPING_USERS: {
      return {
        ...state,
        typingUsers: action.payload
      }
    }

    case UPDATE_SINGLE_REVIEW_TYPING_USER: {
      let typingUsers = Object.values({ ...state.typingUsers })
        .filter(user => user.userId !== action.payload.userId)
        .reduce((prev, current) => {
          return {
            ...prev,
            [current.userId]: { ...current }
          }
        }, {})

      if (action.payload.isTyping) {
        typingUsers[action.payload.userId] = { ...action.payload }
      }

      return {
        ...state,
        typingUsers
      }
    }

    case CHANGE_THREAD_OWNER: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              ownedBy: action.payload.currentOwner
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case OPTING_IN_GUEST_TO_CHAT_SUCCESS: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              subscriptionStatus: 'Active'
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case OPTING_OUT_GUEST_FROM_CHAT_SUCCESS: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              subscriptionStatus: 'DoNotCall'
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case RESOLVE_THREAD_REVIEW_STARTED:
      return {
        ...state,
        currentchatId: null,
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            isResolving: true
          }
        }
      }

    case RESOLVE_THREAD_REVIEW_SUCCESS:
      return {
        ...state,
        currentchatId: null,
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            status: 'Closed',
            isResolving: true
          }
        }
      }

    default:
      return state
  }
}
